import { DROP_SHOW_HIDE } from '../constants'
import {createAction} from "redux-actions";

export const dropShowHide = createAction(DROP_SHOW_HIDE);

export const dropDownShow = () =>  (dispatch) => dispatch(dropShowHide());